/**
 * CONCEIVABLE PACK BROWSER
 * ---------------------------------------------------------------------------
 * Catalog browsing modeled on perfect-packs.com, OK Capsule's own reference
 * storefront, using our real catalog of 60 products.
 *
 * Our front and our brand, their UX and their back end (KK 2026-08-25).
 * Every product is browsable: their embedded widget exposes only 30 of our 60.
 * Checkout hands off to OK Capsule with the pack prefilled.
 */
(function () {
  'use strict';

  var SUPPLY_DAYS = 28;   // their cycle, and it happens to be hers too

  /* KK 2026-08-25: match perfect-packs.com, OK Capsule's own storefront.
     Their model, read off their live site and approved by KK:

       retail is a per pill per day price, already carrying shipping
       pack price = sum(retail) x 28 days, no separate fee
       minimum 4 pills a day, maximum 8, subscribe and save 15%

     Two fields on each catalog entry and they are NOT interchangeable:
       pricePerPill  our COST  (CoQ10 0.1832 x 30 = the $5.50 in Shopify)
       retail        what she pays
     Only `retail` may ever reach the DOM. Median markup is 3.41x, which is
     also what the two products their store does not carry are priced at. */
  var MIN_PILLS = 4;
  var MAX_PILLS = 8;
  var SUB_SAVE = 0.15;  // KK 2026-09-13: the Shopify plan is 15%, and 15% is the real number
  /* KK 2026-09-13 audit: checkout used to hand the pack to OK Capsule's builder,
     which quoted $805.28 for a pack this page priced at $51.52 and filled the cart
     with 112 single bottles. Every pack built here now sells as The Conceivable
     Fertility Pack, with her supplements written on the order so it is packed
     exactly as she built it. */
  /* KK 2026-09-13: "89 has to be for the 5 pack only" (a 9 pill pack was
     selling at $89) and then "why would 4 pills be MORE." 4 or 5 pills is the
     Recommended pack at $89; 6 to 8 pills is the Power pack at $109. */
  var PACKS = {
    recommended: { variant: 48566544171240, price: 89.00 },
    power: { variant: 48567233872104, price: 109.00 }
  };
  // KK 2026-09-13: 4 or 5 pills $89, 6 to 8 pills $109 (4 is the minimum here).
  function packFor(pills) { return pills <= 5 ? PACKS.recommended : PACKS.power; }
  var SELLING_PLAN = 5398331624;      // Monthly subscription, save 15%

  var root = document.getElementById('cv-pbr');
  if (!root) return;

  var script = document.querySelector('script[data-catalog]');
  var CATALOG_URL = script ? script.getAttribute('data-catalog') : null;
  var QUIZ = root.getAttribute('data-quiz') || 'https://kai.conceivable.com/';

  var products = [];
  var catalogMeta = {};
  var pack = {};              // name -> { qty, toa }
  var filters = { q: '', cat: '' };

  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------------------------------------------------------------- render */

  function visible(p) {
    if (filters.cat && p.category !== filters.cat) return false;
    if (filters.q) {
      var hay = (p.name + ' ' + p.category + ' ' + p.short).toLowerCase();
      if (hay.indexOf(filters.q) === -1) return false;
    }
    return true;
  }

  function cardHTML(p) {
    // retail is the customer price and is safe to render. pricePerPill is not.
    // KK 2026-09-02: "lets do daily price and monthly price like .31/day 9/mo".
    // A per-pill number means nothing on its own. What a woman wants to know is
    // what this costs her a day and what it costs her a month.
    var per = '';  // KK 2026-09-13: every pack is one price, so single prices would mislead
    return '' +
      '<article class="cv-pbr__card" data-name="' + esc(p.name) + '">' +
        '<div class="cv-pbr__head">' +
          '<div class="cv-pbr__shot">' +
            (p.image ? '<img class="cv-pbr__thumb" src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<div class="cv-pbr__name">' + esc(p.name) +
              (p.subtitle ? ' <span class="cv-pbr__sub">' + esc(p.subtitle) + '</span>' : '') + '</div>' +
            '<div class="cv-pbr__meta">' + esc(p.serving || 1) + ' ' + esc(p.pillType || 'Capsule') +
              (per ? ' &middot; ' + per : '') + '</div>' +
          '</div>' +
        '</div>' +
        '<p class="cv-pbr__desc">' + esc(p.short) + '</p>' +
        addButton(p.name) +
        '<button class="cv-pbr__readmore" data-detail>Read more</button>' +
      '</article>';
  }

  function addButton(name) {
    var e = pack[name];
    return '<button class="cv-pbr__add' + (e ? ' in' : '') + '" data-add>' +
      (e ? 'In your pack' : '+ Add to pack') + '</button>';
  }

  /** Repaint one card's button instead of rebuilding all 62 cards on a click. */
  function refreshCard(name) {
    var card = root.querySelector('.cv-pbr__card[data-name="' + window.CSS.escape(name) + '"]');
    if (!card) return;
    var btn = card.querySelector('[data-add]');
    if (btn) btn.outerHTML = addButton(name);
  }


  /* ------------------------------------------------------------- detail view
     KK 2026-08-25: the whole point of the pill detail is that it exists and
     nobody can tell. Hence the explicit "Read more" on every card.

     The allergen block is real data, not inferred. freeFrom / contains /
     otherIngredients / warnings are parsed straight out of OK Capsule's own
     Supplement Facts document for that exact product id, which is the same
     document rendered in the iframe below. Never infer an allergen from a
     product name. If a product has no parsed data the block does not render. */

  function allergenHTML(p) {
    var free = p.freeFrom || [], has = p.contains || [];
    if (!free.length && !has.length && !p.otherIngredients) return '';
    var out = '<div class="cv-pbr__spec"><h4>Allergens and diet</h4>';
    if (free.length) out += '<p class="cv-pbr__free"><span>Free from</span> ' + esc(free.join(', ')) + '</p>';
    if (has.length) out += '<p class="cv-pbr__has"><span>Contains</span> ' + esc(has.join(', ')) + '</p>';
    if (p.otherIngredients) out += '<p class="cv-pbr__other"><span>Other ingredients</span> ' + esc(p.otherIngredients) + '</p>';
    if (p.warnings) out += '<p class="cv-pbr__warn">' + esc(p.warnings) + '</p>';
    out += '<p class="cv-pbr__src">Taken from this product\'s Supplement Facts, below. Always check the label on your pouch.</p>';
    return out + '</div>';
  }

  function openDetail(name) {
    var p = find(name);
    if (!p.name) return;
    var per = '';
    var el = document.createElement('div');
    el.className = 'cv-pbr__modal';
    el.innerHTML =
      '<div class="cv-pbr__sheet" role="dialog" aria-modal="true" aria-label="' + esc(p.name) + '">' +
        '<button class="cv-pbr__x" data-close aria-label="Close">&times;</button>' +
        '<div class="cv-pbr__sheet-head">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '<div></div>') +
          '<div>' +
            '<h3>' + esc(p.name) + '</h3>' +
            '<div class="cv-pbr__meta">' + esc(p.serving || 1) + ' ' + esc(p.pillType || 'Capsule') +
              (per ? ' &middot; ' + per : '') + ' &middot; ' + esc(p.category) + '</div>' +
          '</div>' +
        '</div>' +
        '<p class="cv-pbr__sheet-body">' + esc(p.longText || p.short) + '</p>' +
        allergenHTML(p) +
        '<div class="cv-pbr__spec">' +
          '<h4>Dosing</h4>' +
          '<dl>' +
            '<div><dt>Serving</dt><dd>' + esc(p.serving || 1) + ' ' + esc(p.pillType || 'Capsule') + ' a day</dd></div>' +
            '<div><dt>Form</dt><dd>' + esc(p.pillType || 'Capsule') + '</dd></div>' +
            '<div><dt>Supply</dt><dd>' + SUPPLY_DAYS + ' days</dd></div>' +
          '</dl>' +
        '</div>' +
        (p.factPanel ?
          '<div class="cv-pbr__spec"><h4>Supplement facts</h4>' +
          '<iframe class="cv-pbr__sfp" src="' + esc(p.factPanel) + '" title="Supplement facts for ' + esc(p.name) + '" loading="lazy"></iframe></div>' : '') +
        '<button class="cv-pbr__add' + (pack[p.name] ? ' in' : '') + '" data-add-detail>' +
          (pack[p.name] ? 'In your pack' : '+ Add to pack') + '</button>' +
      '</div>';
    // Must mount inside #cv-pbr: every style in this section is scoped to it.
    root.appendChild(el);
    document.body.style.overflow = 'hidden';
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.hasAttribute('data-close')) return closeDetail();
      if (e.target.hasAttribute('data-add-detail')) {
        if (pack[p.name]) delete pack[p.name];
        else if (totalPills() < MAX_PILLS) pack[p.name] = { qty: 1 };
        refreshCard(p.name); renderPack(); closeDetail();
      }
    });
    document.addEventListener('keydown', escClose);
    el.querySelector('[data-close]').focus();
  }

  function escClose(e) { if (e.key === 'Escape') closeDetail(); }

  function closeDetail() {
    var m = root.querySelector('.cv-pbr__modal');
    if (m) m.remove();
    document.body.style.overflow = '';
    document.removeEventListener('keydown', escClose);
  }


  /* One tap builds the prenatal, since OK Capsule has no single prenatal
     product yet. KK 2026-08-25: ask for a daily and you get Women's Daily
     alone; ask for a prenatal and it is the base plus Iron, Choline and an
     Omega. Four pills, which is also the pack minimum. */
  var PRENATAL = ['Women\u2019s Daily', 'Iron', 'Choline', 'Omega 3'];

  /* Sold out until OK Capsule publishes Women's Daily, Choline and Omega 3 to
     our pack builder. Three of the four cannot be ordered, so offering it would
     be promising something checkout cannot complete. KK 2026-08-25. */
  function prenatalReady() {
    return PRENATAL.every(function (n) { return !!find(n).name; });
  }

  function buildPrenatal() {
    if (!prenatalReady()) return;
    PRENATAL.forEach(function (n) {
      if (find(n).name && !pack[n]) pack[n] = { qty: 1 };
    });
    renderCatalog(); renderPack();
    var panel = root.querySelector('.cv-pbr__panel');
    if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


  /* Pill strip along the top, the moving shelf Perfect Packs runs. Built from
     the real catalog so it never goes stale, duplicated once so the -50%
     keyframe loops without a seam. */

  /* Arriving from the ask field on /pages/supplements. She typed something, so
     show it back and put it in the search box. Deliberately NOT mapping her
     words to supplements: which ingredient answers which complaint is a
     clinical call and it is KK's, not this file's. All this does is get her
     to the right shelf with her own words visible. */
  function honourAsk() {
    var q = '';
    try { q = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) { return; }
    q = q.trim();
    if (!q) return;
    var said = $('cv-pbr-said');
    if (said) {
      said.hidden = false;
      said.innerHTML = '<b>You told Kai</b><em>' + esc(q) + '</em>' +
        '<div style="margin-top:7px;font-size:13.5px;color:#8a8681">' +
        'Here is the whole shelf. Search below, or ' +
        '<a href="/pages/supplements#cv-sh-ask" style="color:var(--peri);font-weight:700">say more to Kai</a>.</div>';
    }
    // seed the search with the longest word she used, which is usually the noun
    var word = q.split(/\s+/).filter(function (w) { return w.length > 4; })
                .sort(function (a, b) { return b.length - a.length; })[0];
    if (word) {
      var box = $('cv-pbr-search');
      var hit = products.some(function (p) {
        return (p.name + ' ' + p.short).toLowerCase().indexOf(word.toLowerCase()) !== -1;
      });
      if (hit && box) { box.value = word; filters.q = word.toLowerCase(); }
    }
  }

  function paintPillStrip() {
    var host = document.getElementById('cv-pbr-pillstrip');
    if (!host || !products.length) return;
    var withArt = products.filter(function (p) { return p.image; });
    host.innerHTML = withArt.concat(withArt).map(function (p) {
      return '<figure><img src="' + esc(p.image) + '" alt="" loading="lazy"></figure>';
    }).join('');
  }

  function paintStarter() {
    var b = root.querySelector('[data-prenatal]');
    var note = root.querySelector('.cv-pbr__starter-note');
    if (!b || prenatalReady()) return;
    b.disabled = true;
    b.textContent = 'Prenatal, back shortly';
    b.classList.add('out');
    if (note) note.textContent = 'Our prenatal is briefly out of stock. Everything else is ready to build.';
  }

  function renderCatalog() {
    var host = $('cv-pbr-catalog');
    var shown = products.filter(visible);
    var groups = {};
    shown.forEach(function (p) { (groups[p.category] = groups[p.category] || []).push(p); });

    // A pinned product (the Women's Daily) leads its category, and that
    // category leads the page. KK 2026-08-25.
    Object.keys(groups).forEach(function (k) {
      groups[k].sort(function (a, b) { return (b.pin ? 1 : 0) - (a.pin ? 1 : 0); });
    });
    var order = Object.keys(groups).sort(function (a, b) {
      var pa = groups[a].some(function (x) { return x.pin; }) ? 0 : 1;
      var pb = groups[b].some(function (x) { return x.pin; }) ? 0 : 1;
      return pa - pb || a.localeCompare(b);
    });
    host.innerHTML = order.map(function (cat) {
      return '<section class="cv-pbr__cat">' +
        '<div class="cv-pbr__cat-head"><h3>' + esc(cat) + '</h3>' +
        '<span>' + groups[cat].length + (groups[cat].length === 1 ? ' option' : ' options') + '</span></div>' +
        '<div class="cv-pbr__grid">' + groups[cat].map(cardHTML).join('') + '</div>' +
        '</section>';
    }).join('');
    $('cv-pbr-empty').hidden = shown.length > 0;
  }

  function totalPills() {
    return Object.keys(pack).reduce(function (a, n) { return a + pack[n].qty; }, 0);
  }

  function find(name) {
    return products.filter(function (x) { return x.name === name; })[0] || {};
  }


  /* -------------------------------------------------------- nutrient ceiling
     Sums every UL-bearing nutrient across the pack and flags anything over the
     published adult Tolerable Upper Intake Level (NIH Office of Dietary
     Supplements). The limits and the parsed amounts both live in the catalog,
     read out of each product's own Supplement Facts document, so nothing here
     is estimated.

     It WARNS, it does not block. Whether a given overage should stop a sale is
     a clinical call and it is KK's, not this file's. If she rules on it, turn
     the flagged branch into a disabled checkout, do not soften the number. */
  function overLimits() {
    var limits = (catalogMeta.upperLimits) || {};
    var totals = {};
    Object.keys(pack).forEach(function (n) {
      var nut = find(n).nutrients || {};
      Object.keys(nut).forEach(function (k) {
        totals[k] = (totals[k] || 0) + nut[k] * pack[n].qty;
      });
    });
    var over = [];
    Object.keys(totals).forEach(function (k) {
      var lim = limits[k];
      if (!lim || totals[k] <= lim.ul) return;
      over.push({
        label: lim.label,
        total: Math.round(totals[k] * 10) / 10,
        ul: lim.ul,
        unit: lim.unit
      });
    });
    return over;
  }

  function limitHTML() {
    var over = overLimits();
    if (!over.length) return '';
    var rows = over.map(function (o) {
      return '<li><strong>' + esc(o.label) + '</strong> ' + o.total + ' ' + esc(o.unit) +
             ' a day, above the ' + o.ul + ' ' + esc(o.unit) + ' upper limit</li>';
    }).join('');
    return '<div class="cv-pbr__limit">' +
      '<p class="cv-pbr__limit-h">Worth a look before you order</p>' +
      '<ul>' + rows + '</ul>' +
      '<p class="cv-pbr__limit-src">Compared against the adult upper intake levels published by the ' +
      'NIH Office of Dietary Supplements. Being over is not automatically a problem, but it is ' +
      'worth raising with whoever looks after your care.</p></div>';
  }


  /* 31 of our 60 products are not published to OK Capsule's checkout catalog,
     so they cannot ride the handoff. She used to find that out on the final
     click, after building a whole pack. Tell her the moment it happens, and
     never offer to "continue with the rest" when the rest is under the
     minimum, because that cart would just fail on their side. */
  function stranded() {
    return Object.keys(pack).filter(function (n) { return !find(n).name; });
  }

  /* KK 2026-09-13 audit: okcId only meant "OK Capsule's own builder widget
     accepts this". Checkout no longer goes through that widget. Packs ship from
     the order itself, the same way quiz packs already ship CoQ10, NAC and Omega-3
     (order #10947, fulfilled), so every product in the catalog can be ordered. */
  function sellablePills() {
    return Object.keys(pack).reduce(function (a, n) {
      return a + (find(n).name ? pack[n].qty : 0);
    }, 0);
  }

  function strandedHTML() {
    var out = stranded();
    if (!out.length) return '';
    var sell = sellablePills();
    var line = out.length === 1
      ? '<strong>' + esc(out[0]) + '</strong> cannot go through checkout yet.'
      : '<strong>' + esc(out.join(', ')) + '</strong> cannot go through checkout yet.';
    var fix = sell >= MIN_PILLS
      ? 'The rest of your pack can. Take ' + (out.length === 1 ? 'it' : 'them') + ' out to order now, or '
      : 'That leaves ' + sell + ' that can, under the ' + MIN_PILLS + ' minimum. Swap ' +
        (out.length === 1 ? 'it' : 'them') + ' for something else, or ';
    return '<div class="cv-pbr__stranded"><p>' + line + ' ' + fix +
      '<a href="' + QUIZ + '">ask Kai to source ' + (out.length === 1 ? 'it' : 'them') + '</a>.</p></div>';
  }

  function renderPack() {
    var names = Object.keys(pack);
    var host = $('cv-pbr-items');

    var pills = 0, total = 0;
    var rowTotals = {};
    names.forEach(function (n) {
      var e = pack[n];
      pills += e.qty;
      rowTotals[n] = (find(n).retail || 0) * e.qty * SUPPLY_DAYS;
      total += rowTotals[n];
    });

    if (!names.length) {
      host.innerHTML = '<p class="cv-pbr__muted">Add supplements from the catalog to start building.</p>';
    } else {
      host.innerHTML = names.map(function (n) {
        var e = pack[n];
        return '<div class="cv-pbr__row" data-row="' + esc(n) + '">' +
          '<div>' + esc(n) +
            '<div class="cv-pbr__row-sub">' + e.qty + ' a day' +
              (find(n).name ? '' : ' &middot; <span class="cv-pbr__flag">not orderable yet</span>') + '</div>' +
          '</div>' +
          '<div class="cv-pbr__step">' +
            '<button data-dec aria-label="Fewer">-</button>' +
            '<span>' + e.qty + '</span>' +
            '<button data-inc aria-label="More">+</button>' +
          '</div></div>';
      }).join('');
    }

    $('cv-pbr-count').textContent = names.length + (names.length === 1 ? ' item' : ' items');
    $('cv-pbr-pills').textContent = pills;
    var price = packFor(sellablePills()).price;
    /* KK 2026-09-13: the per supplement and per day lines suggested different
       charges than the pack price. Gone; the pack price is the only number. */
    $('cv-pbr-total').textContent = money(pills ? price : 0);
    $('cv-pbr-sub').textContent = pills >= MIN_PILLS ? money(price * (1 - SUB_SAVE)) : '--';

    /* KK 2026-09-13: "remove this and lets ask ok cap again about these." The
       upper limit warning (Vitamin D, Niacin) is off until OK Capsule answers.
       limitHTML() is kept so it can come back in one line. */
    var warn = $('cv-pbr-limits');
    if (warn) warn.innerHTML = stranded().length ? strandedHTML() : '';

    var gate = $('cv-pbr-gate');
    if (pills === 0) {
      gate.hidden = true;
    } else if (pills < MIN_PILLS) {
      gate.hidden = false;
      gate.innerHTML = 'A pack starts at <strong>' + MIN_PILLS + ' a day</strong>. ' +
        'Add ' + (MIN_PILLS - pills) + ' more and you are ready to ship.';
    } else if (pills >= MAX_PILLS) {
      gate.hidden = false;
      gate.innerHTML = '<strong>' + MAX_PILLS + ' a day is the most</strong> that fits in a daily ' +
        'pouch. Take something out to swap it.';
    } else {
      gate.hidden = false;
      gate.innerHTML = 'Subscribe and save 15%. Skip, pause or cancel whenever you want.';
    }

    var cta = $('cv-pbr-checkout');
    var sell = sellablePills();
    cta.disabled = pills < MIN_PILLS || sell < MIN_PILLS;
    cta.textContent = (stranded().length && sell >= MIN_PILLS)
      ? 'Checkout with the ' + sell + ' that can ship'
      : 'Continue to checkout';
    cta.removeAttribute('data-seen');
  }

  /* --------------------------------------------------------------- events */

  root.addEventListener('click', function (e) {
    var t = e.target;

    if (t.hasAttribute && t.hasAttribute('data-prenatal')) {
      buildPrenatal();
      return;
    }

    var card = t.closest ? t.closest('.cv-pbr__card') : null;
    if (card && t.hasAttribute('data-detail')) {
      openDetail(card.getAttribute('data-name'));
      return;
    }
    if (card && t.hasAttribute('data-add')) {
      var name = card.getAttribute('data-name');
      if (pack[name]) delete pack[name];
      else if (totalPills() < MAX_PILLS) pack[name] = { qty: 1 };
      else { renderPack(); return; }
      refreshCard(name); renderPack();
      return;
    }

    var row = t.closest ? t.closest('[data-row]') : null;
    if (row) {
      var n = row.getAttribute('data-row');
      if (t.hasAttribute('data-inc') && totalPills() < MAX_PILLS) pack[n].qty += 1;
      if (t.hasAttribute('data-dec')) {
        pack[n].qty -= 1;
        if (pack[n].qty < 1) delete pack[n];
      }
      refreshCard(n); renderPack();
      return;
    }

  });

  $('cv-pbr-search').addEventListener('input', function (e) {
    filters.q = e.target.value.trim().toLowerCase();
    renderCatalog();
  });
  $('cv-pbr-cat').addEventListener('change', function (e) {
    filters.cat = e.target.value;
    renderCatalog();
  });

  /* Kai's picks arrive as ?pack=Name|Name so she never rebuilds what Kai chose. */
  function honourPack() {
    var raw = '';
    try { raw = new URLSearchParams(window.location.search).get('pack') || ''; } catch (e) { return; }
    raw.split('|').forEach(function (n) {
      var p = find(n.trim());
      if (p.name && !pack[p.name] && totalPills() < MAX_PILLS) pack[p.name] = { qty: 1 };
    });
  }

  $('cv-pbr-checkout').addEventListener('click', function () {
    // Gate on pills that can ship, the same number the button enables on.
    if (sellablePills() < MIN_PILLS) return;
    var cta = $('cv-pbr-checkout');
    var names = Object.keys(pack).filter(function (n) { return !!find(n).name; });
    var props = {};
    names.forEach(function (n, i) { props[(i + 1) + '. ' + n] = pack[n].qty + ' a day'; });
    props['Your Personalized Pack'] = names.join(', ');
    var packName = ($('cv-pbr-name').value || '').trim();
    if (packName) props['Pack name'] = packName.slice(0, 60);
    props._source = 'build-your-pack';
    cta.disabled = true;
    cta.textContent = 'Adding your pack';
    var packVariant = packFor(sellablePills()).variant;
    /* KK 2026-09-13: "i accidentally got 3 packs in my cart ... no way to reduce
       that." Every tap added another pack. Any pack already in the cart comes out
       first, so the cart holds exactly the one she just built. Other products,
       like a ring or Myo-Inositol, are left alone. */
    var packIds = [PACKS.recommended.variant, PACKS.power.variant, 48566544204008];
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (it) {
          if (packIds.indexOf(it.variant_id) !== -1) updates[it.key] = 0;
        });
        if (!Object.keys(updates).length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: packVariant, quantity: 1, selling_plan: SELLING_PLAN, properties: props }] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        cta.disabled = false;
        cta.textContent = 'Continue to checkout';
        var gate = $('cv-pbr-gate');
        gate.hidden = false;
        gate.innerHTML = 'Your pack did not reach the cart. Try again, or email ' +
          '<a href="mailto:help@conceivable.com">help@conceivable.com</a> and we will set it up.';
      });
  });

  /* ----------------------------------------------------------------- boot */

  fetch(CATALOG_URL)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      products = data.products || [];
      catalogMeta = data;
      var cats = [];
      products.forEach(function (p) { if (cats.indexOf(p.category) === -1) cats.push(p.category); });
      cats.sort();
      var sel = $('cv-pbr-cat');
      cats.forEach(function (c) {
        var o = document.createElement('option');
        o.value = c; o.textContent = c;
        sel.appendChild(o);
      });
      honourAsk();
      honourPack();
      renderCatalog();
      renderPack();
      paintStarter();
      paintPillStrip();
    })
    .catch(function () {
      $('cv-pbr-catalog').innerHTML =
        '<p class="cv-pbr__empty">The catalog did not load. ' +
        '<a href="' + QUIZ + '">Take the quiz instead</a> and Kai will build your pack.</p>';
    });
})();
